import React from 'react';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import ArrayUtil from '../../../utils/ArrayUtil';

const DragHandle = SortableHandle(() => (
  <div className="ability-handle">
    <i className="fa fa-align-justify fa-lg" aria-hidden="true" />
  </div>
));

const InterestsBenchmarksItem = SortableElement((props) => {
  const {
    dimensionRange, hintCSRange, hintJPSRange, hintSJLRange, isEdit,
  } = props;

  if (!dimensionRange) return <div />;

  return (
    <div className="ability ability--draggable">
      <div className="ability-split">
        <div className="ability-content">
          <div className="ability-label">{dimensionRange.displayName}</div>
          <div className="ability-text t-small">
            <p>{dimensionRange.description}</p>
          </div>
        </div>

        <div className="ability-hint">
          {hintCSRange && <span className="CS">{hintCSRange.priority}</span>}
          {hintJPSRange && <span className="JPS">{hintJPSRange.priority}</span>}
          {hintSJLRange && <span className="SJL">{hintSJLRange.priority}</span>}
        </div>

        {isEdit && <DragHandle />}
      </div>
    </div>
  );
});

const InterestsBenchmarksList = SortableContainer(({ dimensionBenchmarks, isEdit, onChange }) => {
  if (ArrayUtil.isEmpty(dimensionBenchmarks)) return null;
  return (
    <div className="abilityContainer">
      {dimensionBenchmarks.map((d, index) => (
        <InterestsBenchmarksItem
          index={index}
          key={d.dimensionRange.code}
          isEdit={isEdit}
          template={d.template}
          dimensionRange={d.dimensionRange}
          onChange={onChange}
          hintCSRange={d.hintCSRange}
          hintJPSRange={d.hintJPSRange}
          hintSJLRange={d.hintSJLRange}
        />
      ))}
    </div>
  );
});

export default InterestsBenchmarksList;
